import {asyncRouterMap, constantRouterMap} from '@/router/index';
function hasPermission(roles, route) {
    if(route.hidden){
        return true;
    }
    // 返回用户中心定义的名字
    if(Array.isArray(roles)){
        roles.forEach( i => {
            if(i.permission === route.permission){
                route.name = i.name;
            }
        });
        return roles.some(role => role.permission === route.permission)
    }
    return false
}

function recursiveRouters(roles,arr){
    return arr.filter(v => {
        if (v.children && v.children.length > 0) v.children = recursiveRouters(roles,v.children);
        return hasPermission(roles, v)
    });
}

function hasWhite(roles, route) {
  if(roles.path === route.path){
    return true;
  }
  return false;
}
function whiteRouters(roles,arr){
  return arr.filter(v => {
    if (v.children && v.children.length > 0) v.children = whiteRouters(roles,v.children);
    return hasWhite(roles, v)
  });
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        permissionList:[]//存储后台取到的所有非路由的权限菜单（按钮或者输入框）
    },

    mutations: {
        SET_ROUTERS: (state, routers) => {
           state.addRouters = routers;
           state.routers = constantRouterMap.concat(routers);
        },
        SET_PERMISSION:(state,list)=>{//放入permissionList存储权限信息
            state.permissionList=JSON.parse(JSON.stringify(list)).filter(i=>{
              return i.id&&i.permission&&!i.href
            })
        }
    },
    actions: {
        GenerateRoutes({commit}, data) {
            return new Promise(resolve => {
                //放开所有菜单权限
                /*asyncRouterMap.push({ path: '*', name: '404', redirect: '/404',hidden: true, });
                commit('SET_ROUTERS', asyncRouterMap);*/

                //获取当前用户权限
                if(Array.isArray(data)){
                    // console.log(data,'所有权限菜单')
                  commit('SET_PERMISSION', data);
                }
                const accessedRouters = recursiveRouters(data,asyncRouterMap);
                accessedRouters.push({ path: '*', name: '404', redirect: '/resources/404',hidden: true, });
                commit('SET_ROUTERS', accessedRouters);
                resolve();
            })
        },
      whiteRoutes({commit}, data) { //白名单
        return new Promise(resolve => {
          //获取当前用户权限
          const accessedRouters = whiteRouters(data,asyncRouterMap);
          accessedRouters.push({ path: '*', name: '404', redirect: '/resources/404',hidden: true, });
          commit('SET_ROUTERS', accessedRouters);
          resolve();
        })
      }
    },

};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js